import { JsonObject } from '../../app/json/jsonValue.js';
import { GetParentJsonValueHandler } from './getParentJsonValueHandler.js';
import type { ITransientStore } from './iTransientStore.js';

/**
 * Abstract base class for server-side dynamic data providers.
 *
 * Data handlers execute on the server only. getData is the single entry point:
 * a handler reads its inputs (paramJson/componentJson/configJson and any source it
 * owns) and returns the data to merge into componentJson. There is no client-side
 * execution, no raw-data round-trip, and no separate raw/process split at the base.
 */
export abstract class IData {
    /**
     * Gets the full type name for DynamicData operation tracking
     */
    abstract get typeName(): string;

    /**
     * Produces the dynamic data for a component in a single server-side pass.
     * Override to read the handler's source and return the fields to merge into
     * componentJson. Return an empty JsonObject when the handler does not apply
     * (e.g. the component does not declare this handler's trigger key).
     */
    getData(
        appSite: string,
        appView: string,
        appFile: string,
        componentName: string,
        componentDepth: number,
        resolvedAppSite: string,
        resolvedComponentName: string,
        paramJson: JsonObject,
        componentJson: JsonObject,
        transientStore: ITransientStore,
        configJson: JsonObject | null = null,
        getParentJsonValue: GetParentJsonValueHandler | null = null
    ): JsonObject {
        return new JsonObject();
    }
}
